import { IProduct } from 'src/@interfaces'
import { Api } from './api'
import { ProductsOnSaleParams } from './service.types'
import { getSlugOrState } from 'src/helpers/getSlugOrState'

export function getProductsOnSale(params: ProductsOnSaleParams) {
  const { reseller, pagination, isGenericReseller } = params

  return Api.post<{ products: IProduct[] }>(`/product/`, {
    onSale: true,
    ...getSlugOrState({ reseller, isGenericReseller }),
    ...pagination,
  })
}
